var _defs, _g, _use;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDust(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 99.5,
    x2: 232.6,
    y1: 30.7,
    y2: 261.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3f7fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f3f7fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#deeafb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 6,
    x2: 18,
    y1: 169.6,
    y2: 190.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fde68a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fde68a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fde171"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#b",
    id: "c",
    x1: 66,
    x2: 78,
    y1: 169.6,
    y2: 190.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#b",
    id: "d",
    x1: 38,
    x2: 50,
    y1: 137.6,
    y2: 158.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#b",
    id: "e",
    x1: 98,
    x2: 110,
    y1: 137.6,
    y2: 158.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#b",
    id: "f",
    x1: 70,
    x2: 82,
    y1: 101.6,
    y2: 122.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#b",
    id: "g",
    x1: 130,
    x2: 142,
    y1: 101.6,
    y2: 122.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#b",
    id: "h",
    x1: 102,
    x2: 114,
    y1: 69.6,
    y2: 90.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#b",
    id: "i",
    x1: 162,
    x2: 174,
    y1: 69.6,
    y2: 90.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#b",
    id: "j",
    x1: 134,
    x2: 146,
    y1: 33.6,
    y2: 54.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#b",
    id: "k",
    x1: 194,
    x2: 206,
    y1: 33.6,
    y2: 54.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#b",
    id: "l",
    x1: 166,
    x2: 178,
    y1: 1.6,
    y2: 22.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#b",
    id: "m",
    x1: 226,
    x2: 238,
    y1: 1.6,
    y2: 22.4
  }), /*#__PURE__*/React.createElement("symbol", {
    id: "o",
    viewBox: "0 0 350 222"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    stroke: "#e6effc",
    strokeMiterlimit: 10,
    strokeWidth: 6,
    d: "m291 107-2.5.1A83.9 83.9 0 00135.6 43 56 56 0 0051 91a56.6 56.6 0 00.8 9A60 60 0 0063 219l4-.2v.2h224a56 56 0 000-112Z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "p",
    viewBox: "0 0 244 192"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 180,
    r: 12,
    fill: "url(#b)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "-1s",
    dur: ".67s",
    repeatCount: "indefinite",
    values: ".5; 1; .5"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 180,
    r: 12,
    fill: "url(#c)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "-1.08s",
    dur: ".67s",
    repeatCount: "indefinite",
    values: ".5; 1; .5"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 148,
    r: 12,
    fill: "url(#d)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "-1.16s",
    dur: ".67s",
    repeatCount: "indefinite",
    values: ".5; 1; .5"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 148,
    r: 12,
    fill: "url(#e)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "-1.24s",
    dur: ".67s",
    repeatCount: "indefinite",
    values: ".5; 1; .5"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 112,
    r: 12,
    fill: "url(#f)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "-1.32s",
    dur: ".67s",
    repeatCount: "indefinite",
    values: ".5; 1; .5"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 136,
    cy: 112,
    r: 12,
    fill: "url(#g)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "-1.40s",
    dur: ".67s",
    repeatCount: "indefinite",
    values: ".5; 1; .5"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 80,
    r: 12,
    fill: "url(#h)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "-1.48s",
    dur: ".67s",
    repeatCount: "indefinite",
    values: ".5; 1; .5"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 80,
    r: 12,
    fill: "url(#i)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "-1.56s",
    dur: ".67s",
    repeatCount: "indefinite",
    values: ".5; 1; .5"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 44,
    r: 12,
    fill: "url(#j)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "-1.64s",
    dur: ".67s",
    repeatCount: "indefinite",
    values: ".5; 1; .5"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 44,
    r: 12,
    fill: "url(#k)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "-1.72s",
    dur: ".67s",
    repeatCount: "indefinite",
    values: ".5; 1; .5"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 172,
    cy: 12,
    r: 12,
    fill: "url(#l)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "-1.80s",
    dur: ".67s",
    repeatCount: "indefinite",
    values: ".5; 1; .5"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 232,
    cy: 12,
    r: 12,
    fill: "url(#m)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "-1.88s",
    dur: ".67s",
    repeatCount: "indefinite",
    values: ".5; 1; .5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h512L0 512V0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#n)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#o",
    width: 350,
    height: 222,
    transform: "translate(85 145)"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    width: 244,
    height: 192,
    transform: "translate(192 182)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDust);
export default __webpack_public_path__ + "static/media/dust.0307a1c5a37caece25afade3789d75ef.svg";
export { ForwardRef as ReactComponent };